import { z } from 'zod';
import { patchSchema, slugSchema } from './common.ts';

export const TENANT_KINDS = ['reservoir', 'hydro_plant', 'canal', 'pump_station', 'other'] as const;
export const tenantKindSchema = z.enum(TENANT_KINDS);
export type TenantKind = z.infer<typeof tenantKindSchema>;

export const createOrganizationSchema = z.object({
  name: z.string().trim().min(2).max(160),
  slug: slugSchema,
  description: z.string().trim().max(2000).optional(),
});
export const updateOrganizationSchema = patchSchema(createOrganizationSchema);
export type CreateOrganizationInput = z.infer<typeof createOrganizationSchema>;

export interface OrganizationDto {
  id: string;
  name: string;
  slug: string;
  description: string | null;
  logoFileId: string | null;
  tenantCount: number;
  createdAt: string;
  updatedAt: string;
}

export const geoPointSchema = z.object({
  lat: z.number().min(-90).max(90),
  lng: z.number().min(-180).max(180),
});

export const createTenantSchema = z.object({
  name: z.string().trim().min(2).max(160),
  slug: slugSchema,
  kind: tenantKindSchema.default('reservoir'),
  description: z.string().trim().max(2000).optional(),
  location: geoPointSchema.nullish(),
  /** Site id of this object in the ATNT unified server ("единый сервер"), used by the live-data connector. */
  externalSiteId: z.string().trim().max(128).nullish(),
  sortOrder: z.number().int().default(0),
});
export const updateTenantSchema = patchSchema(createTenantSchema);
export type CreateTenantInput = z.infer<typeof createTenantSchema>;

export interface TenantDto {
  id: string;
  organizationId: string;
  name: string;
  slug: string;
  kind: TenantKind;
  description: string | null;
  location: { lat: number; lng: number } | null;
  externalSiteId: string | null;
  sortOrder: number;
  memberCount: number;
  createdAt: string;
  updatedAt: string;
}
